/**
 * Configuration for all supported signing methods
 * Defines the available options, descriptions, and compatible chains.
 */
export const SIGNING_METHODS = [
  {
    value: 'eip712' as const,
    label: 'EIP-712 Typed Data',
    description:
      'Test wallet ability to sign structured data (USDC authorization)',
    signingMethod:
      'Use eth_signTypedData_v4 RPC method. Returns an off-chain signature (0x...).',
    chains: ['ethereum-sepolia', 'arbitrum-sepolia', 'base-sepolia'],
  },
  {
    value: 'eip1559' as const,
    label: 'EIP-1559 Raw Transaction',
    description:
      'Test wallet ability to sign raw transactions with dynamic fees',
    signingMethod:
      "Use eth_signTransaction RPC method or your wallet's transaction signing. Returns a signed transaction (0x...). Please make sure the transaction is signed without broadcast.",
    chains: ['ethereum-sepolia', 'arbitrum-sepolia', 'base-sepolia'],
  },
  {
    value: 'solana' as const,
    label: 'Solana Ed25519',
    description: 'Test wallet ability to sign Solana SPL token transfers',
    signingMethod:
      "Use your wallet's Solana signing feature. Returns a base58-encoded signature (87-88 characters).",
    chains: ['solana-devnet'],
  },
]

/**
 * Default CSS classes for consistent styling.
 */
export const DEFAULT_CLASSES = {
  container:
    'mx-auto w-full max-w-4xl rounded-sm border border-neutral-subtle bg-white',
  header: 'border-b border-neutral-subtle bg-neutral-subtle px-6 py-4',
  content: 'p-6',
  stepIndicator: 'border-b border-neutral-subtle px-6 py-4',
  button: {
    primary:
      'rounded-md border border-transparent bg-blue-600 px-4 py-2 text-white type-body-base-bold hover:bg-blue-700',
    secondary:
      'rounded-md border border-neutral-subtle bg-white px-4 py-2 text-neutral-strong type-body-base-bold hover:bg-neutral-subtle-hovered',
  },
} as const
